<template>
    <div class="max-w-[80%] rounded-md border border-violet-200 bg-violet-50 px-3 py-2" data-testid="role-play-started-card">
        <div class="flex items-center gap-2">
            <span class="rounded-full bg-violet-700 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-white">Role-play started</span>
            <span class="text-xs text-violet-900">
                You're rehearsing with <strong>{{ data.persona_name }}</strong
                ><span v-if="data.persona_relationship">, your {{ data.persona_relationship }}</span>
            </span>
        </div>
        <div v-if="data.situation" class="mt-1 text-[11px] text-violet-800"><span class="font-medium">Situation:</span> {{ data.situation }}</div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { RolePlayStartedResult } from "../types";

const props = defineProps<{ result: RolePlayStartedResult; toolName: string }>();
const data = computed<RolePlayStartedResult>(() => props.result);
</script>
